import * as React from 'react';
import {useNavigation} from 'react-day-picker';
import moment from 'moment';
import {
  ChevronLargeLeftIcon,
  ChevronLargeRightIcon,
  HStack,
  IconButton,
  Spacer,
  Text,
} from '@packages/systems/spring';
import {useDatePickerContext} from './DatePickerContext';

type CalendarCaptionprops = {
  displayMonth: Date;
};

export const DatePickerCaption = ({displayMonth}: CalendarCaptionprops) => {
  const {setGoToDate} = useDatePickerContext();
  const {goToMonth, nextMonth, previousMonth} = useNavigation();
  const monthLabel = moment(displayMonth).format('MMMM');
  const yearLabel = moment(displayMonth).format('yyy');

  /**
   * Work-around.
   * Used to lift the `goToMonth` function from the react-day-picker library
   * to our DatePicker component.
   *
   * The react-day-picker `goToMonth` function is used to navigate to a
   * specific month. We use this to smoothen the (visual) transition when
   * selecting any date range.
   */
  React.useEffect(() => {
    setGoToDate(goToMonth);
    // eslint-disable-next-line react-hooks/react-compiler -- pre-ratchet baseline (BLOOP-3033)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HStack className="items-center">
      <HStack spacing={1}>
        <Text colorVariant="primary">{monthLabel}</Text>
        <Text colorVariant="primary">{yearLabel}</Text>
      </HStack>
      <Spacer />
      <HStack isFullWidth={false} spacing={1}>
        <IconButton
          Icon={ChevronLargeLeftIcon}
          isDisabled={!previousMonth}
          label="Previous month"
          onClick={() => previousMonth && goToMonth(previousMonth)}
        />
        <IconButton
          Icon={ChevronLargeRightIcon}
          isDisabled={!nextMonth}
          label="Next month"
          onClick={() => nextMonth && goToMonth(nextMonth)}
        />
      </HStack>
    </HStack>
  );
};
